<script>
    export let text = "";

    let isSuccess = false;
    export let iconClass = 'far fa-clipboard';
    export let title = 'Kopiera';

    function copy() {
        if (!navigator.clipboard) {
            return;
        }

        navigator.clipboard.writeText(text).then(
            function () {
                isSuccess = true;

                setTimeout(() => {
                    isSuccess = false;
                }, 1000);
            },
            function (err) {
                console.error("Async: Could not copy text: ", err);
            }
        );
    }
</script>

<button
    class="{isSuccess ? 'fas fa-check-circle' : iconClass}"
    on:click={copy}
    title="{title}"
/>

<style>
    button {
        width: 24px;
        height: 24px;
        border: none;
        background: none;

        margin: 0;
    }

    button {
        color: rgb(0, 100, 200);
    }

    button.fa-check-circle {
        color: rgb(100, 200, 0);
    }
</style>
